import { useTranslation } from 'react-i18next'
import { StackAtom } from '@justomx/atlas-components'
import { GroupOfProduct } from '../../molecule/v2/GroupOfProduct.molecule'
import { type ProductWithAlertInfo } from 'types/model'

interface InventoryProductListProps {
  products: ProductWithAlertInfo[]
  selectable?: boolean
  selectedInventoryProducts?: ProductWithAlertInfo[]
  onSelect?: (p: ProductWithAlertInfo) => void
}

export const InventoryProductList = ({
  products = [],
  selectable = false,
  selectedInventoryProducts,
  onSelect
}: InventoryProductListProps) => {
  const { t } = useTranslation('global')

  const urgentProducts = products.filter((p) => p.alert === 'Urgent')
  const criticalProducts = products.filter((p) => p.alert === 'Critical')
  const warningProducts = products.filter((p) => p.alert === 'Warning')
  const productWithoutAlerts = products.filter((p) => p.alert === 'None')

  return (
    <StackAtom>
       <GroupOfProduct
        title={t('fast-scan-product.title-critical-alerts')}
        variant="urgent"
        products={urgentProducts}
        selectable={selectable}
        selectedInventoryProducts={selectedInventoryProducts}
        onSelect={onSelect}
      />
      <GroupOfProduct
        title={t('fast-scan-product.title-critical-alerts')}
        variant="critical"
        products={criticalProducts}
        selectable={selectable}
        selectedInventoryProducts={selectedInventoryProducts}
        onSelect={onSelect}
      />
      <GroupOfProduct
        title={t('fast-scan-product.title-warning-alerts')}
        variant="warning"
        products={warningProducts}
        selectable={selectable}
        selectedInventoryProducts={selectedInventoryProducts}
        onSelect={onSelect}
      />
      <GroupOfProduct
        title={t('fast-scan-product.title-no-alerts')}
        products={productWithoutAlerts}
        selectable={selectable}
        selectedInventoryProducts={selectedInventoryProducts}
        onSelect={onSelect}
      />
    </StackAtom>
  )
}
